// components/SubHeader.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import DateRangeInput from './DataRangeInput';

const SubHeader = ({ startDate, endDate, setStartDate, setEndDate, handleGenerate, loading }) => {
  return (
    <Container className="mt-3 mb-3">
      <Row>
        <Col>
          <DateRangeInput
            startDate={startDate}
            endDate={endDate}
            setStartDate={setStartDate}
            setEndDate={setEndDate}
            handleGenerate={handleGenerate}
            loading={loading}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default SubHeader;
